export const EID_PAGE_SCHEDULE = {
  startsAt: "2026-03-21T00:00:00+05:00",
  endsAt: "2026-03-23T00:00:00+05:00",
} as const;
